import React from 'react';

function Assistance() {
  return (
    <body>
    <h1>confidentiality policy </h1>

 
    

    <p> - We use revenue payment services, therefore user information will be shared with the company , more information can be found here https://www.revenuecat.com/ .the company will use customer data and sell them for business purposes.
    </p>

    <p> - As part of our tracking and allocating advertisement information, we use appsflyer services,therefore user information will be shared with the company more information about their policies can be on their company website. the company might use customer data and sell them for business purposes.
    </p>


      <p> The data are hosted on firebase server, which is owned by alphabet inc ( google), user information might be used for business purposes.</p>
 
 
 <p> - User data, which are email addresses, physical traits, and some behavioral traits,
         are used only for the purpose to track subscription status and deliver a better and more useful user experience. 
        User data will not be sold by our company for any purpose.</p>

   <p> - Our company will use user information only for internal purposes like identifying the user, the data will no be shared not used for any external commercial use</p>

   <p> To request user data deletion, please contact support@createawesomeapps.tn .</p>
      <p><b> Email adress:</b> support@createawesomeapps.tn </p>
      </body>
  );
}

export default Assistance;
